import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Start of old Api
    fetchStore(ctx){
        return new Promise((resolve, reject) => {
            axiosIns.get('/store/'+getUserData().store_id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    addContact(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/contact/image', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    // End of old Api
    // Start of new api

    fetchContacts(ctx, queryParams){
      return new Promise((resolve, reject) => {
          axiosIns.get('/contact/list', {params:queryParams})
          .then(response=>resolve(response))
          .catch(error=>reject(error))
      })
    },
    updateContact(ctx, data) {
      return new Promise((resolve, reject) => {
          axiosIns.post('/contact', data,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
          )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteContact(ctx, queryParams)
    {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/contact', {params:queryParams})
        .then(response=>resolve(response))
        .catch(error=>reject(error))
    })
    }




  },
}
